// 업종 색상 대비 텍스트 색상 계산 (API가 내려주는 동적 색상용)

export function contrastText(hex?: string): string {
  if (!hex) return "#ffffff";
  const raw = hex.trim().replace("#", "");
  const h = raw.length === 3 ? raw.split("").map((c) => c + c).join("") : raw;
  if (h.length !== 6 || /[^0-9a-fA-F]/.test(h)) return "#ffffff";
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance > 165 ? "#1f2937" : "#ffffff";
}

export function validColor(hex?: string): string | null {
  if (!hex) return null;
  const h = hex.trim();
  if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(h)) return h;
  if (/^rgb(a)?\(/i.test(h)) return h;
  return null;
}